import { Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import SelectConfig from "./SelectConfig";
import { useEffect } from "react";

const ShocksForm = ({config, setConfig, errorShock, setErrorShock,}) => {
    const {t} = useTranslation()

    const onChangeConfig = (e, key) => {
        var newValue = e.target.value
        setConfig((prevConfig) => ({
            ...prevConfig,
            device_setting: {
                ...prevConfig?.device_setting,
                shocks: {
                ...prevConfig.device_setting.shocks,
                [key]: newValue,
                },
            },
        }));
    }

    return (<>
        <Grid item xs={12}>
              <Typography
                color="secondary"
                style={{
                  fontWeight: 500,
                  fontSize: 22,
                  lineHeight: "30px",
                  marginTop: 18,}}>
                {t("devices.setUp.shock.title")}
              </Typography>
            </Grid>
            <EnergyModule
              label={t("devices.setUp.energyAdult1Label")}
              setConfig={setConfig}
              config={config}
              type={"energy1_adult"}
              checkType={"energy1_adult"}
              errorLabel={t("devices.setUp.energy.overEnergy.error")}
              isAdult={true}
              onChangeConfig={onChangeConfig}
            />
            <EnergyModule
              label={t("devices.setUp.energyAdult2Label")}
              setConfig={setConfig}
              config={config}
              type={"energy2_adult"}
              checkType={"energy1_adult"}
              errorLabel={t("devices.setUp.energy.overEnergy.error")}
              isAdult={true}
              onChangeConfig={onChangeConfig}
            />
            <EnergyModule
              label={t("devices.setUp.energyAdult3Label")}
              setConfig={setConfig}
              config={config}
              type={"energy3_adult"}
              checkType={"energy2_adult"}
              errorLabel={t("devices.setUp.energy.overEnergy.error")}
              isAdult={true}
              onChangeConfig={onChangeConfig}
            />
            <EnergyModule
              label={t("devices.setUp.energyPediatric1Label")}
              setConfig={setConfig}
              config={config}
              type={"energy1_pediatric"}
              checkType={"energy1_pediatric"}
              errorLabel={t("devices.setUp.energy.overEnergy.error")}
              isAdult={false}
              onChangeConfig={onChangeConfig}
            />
            <EnergyModule
              label={t("devices.setUp.energyPediatric2Label")}
              setConfig={setConfig}
              config={config}
              type={"energy2_pediatric"}
              checkType={"energy1_pediatric"}
              errorLabel={t("devices.setUp.energy.overEnergy.error")}
              isAdult={false}
              onChangeConfig={onChangeConfig}
            />
            <EnergyModule
              label={t("devices.setUp.energyPediatric3Label")}
              setConfig={setConfig}
              config={config}
              type={"energy3_pediatric"}
              checkType={"energy2_pediatric"}
              errorLabel={t("devices.setUp.energy.overEnergy.error")}
              isAdult={false}
              onChangeConfig={onChangeConfig}
            />
            <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
              <SelectConfig
                label={t("devices.setUp.consecutive_socks")}
                value={config?.device_setting?.shocks?.consecutive_shocks}
                onChange={(e) => onChangeConfig(e, 'consecutive_shocks') }
                values={[1, 2, 3, 4]}
              />
            </Grid>
    </>)

}

const EnergyModule = ({ label, setConfig, config, type, checkType, errorLabel, isAdult, onChangeConfig }) => {
  let values = isAdult
    ? [
        { key: 150, value: "150 J" },
        { key: 175, value: "175 J" },
        { key: 200, value: "200 J" },
      ]
    : [
        { key: 50, value: "50 J" },
        { key: 65, value: "65 J" },
        { key: 75, value: "75 J" },
        { key: 90, value: "90 J" },
        { key: 100, value: "100 J" },
      ];

  return (
    <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
      <SelectConfig
        label={label}
        value={config?.device_setting?.shocks?.[type]}
        onChange={(e) => onChangeConfig(e, type)}
        error={config.device_setting.shocks[type] < config.device_setting.shocks[checkType]}
        helperText={config.device_setting.shocks[type] < config.device_setting.shocks[checkType] && errorLabel}
        kv
        values={values}
      />
    </Grid>
  );
};

export default ShocksForm